import axios from "../../utils/axios";

async function createExpense(payload) {
  return await axios.post("single/transactions/expense", payload);
}

const transactionService = {
  createExpense,
};

export default transactionService;
